import PostRequest from 'components/common/PostRequest.jsx';
import { defaultRequestQueueManager as requestQueueManager } from 'components/layout_and_quote_builder/utils/RequestQueueManager.js';

/**
 * QueuedPostRequest - A wrapper around PostRequest that uses the RequestQueueManager
 * to limit concurrent requests.
 *
 * This ensures that only a limited number of requests are in-flight at once,
 * preventing server overload when many components try to fetch data simultaneously.
 *
 * Note: Uses the default request queue manager with concurrency=3.
 * For sequential execution (concurrency=1), create a dedicated RequestQueueManager instance.
 *
 * @param {Object} props - Same props as PostRequest
 * @returns {Promise} - Promise that resolves when request completes
 */
const QueuedPostRequest = (props) => {
  // PostRequest now returns a Promise, so we just wrap it and enqueue it
  const requestFn = () => PostRequest(props);
  return requestQueueManager.enqueue(requestFn);
};

export default QueuedPostRequest;
